module.exports = __webpack_public_path__ + "17188d54e7fd9bf43fec510b308b24a3.svg";